import Axios from "axios";
import { lv3_api_gateway } from "../config/config"
import { loading } from "../helpers/default";
import { error_handle } from "../helpers/error";


class Testnet_account{
    constructor(){
        this.url = lv3_api_gateway
    }

    get(data={}){
        loading(true, 'Loading...')
        return Axios.request({
            url: this.url + '/testnet_account/get_all',
            method: "POST",
            data:{...data},
            withCredentials: true, 
        })

            .then(response => {
                loading(false, 'Loading...')
                response = response['data'];
                if(response['result']) return response
                error_handle(response)

            })
            .catch(error => {
                error_handle(error)
            })
    }

    


}


export default Testnet_account